import type { Locale } from "@project/i18n";
import { localeToIntlTag } from "@project/i18n";

/** Reparto guardado en basis points: 10_000 = 100 %. */
export function formatSplitBpsAsPercent(bps: number, locale: Locale): string {
  const tag = localeToIntlTag(locale);
  return new Intl.NumberFormat(tag, {
    style: "percent",
    maximumFractionDigits: 1,
    minimumFractionDigits: 0,
  }).format(bps / 10000);
}
